// @core/api/endpoints/document/get_document_policy_by_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DocumentPolicyResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Get entity policy
 * Returns the document policy directly attached to the specified entity (if any). Does NOT resolve inheritance — use ResolveDocumentContext for that.
 */
export async function GetDocumentPolicyByEntity(
  entity_type: string,
  entity_id: string,
  options?: RequestOptions
): Promise<DocumentPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:entity_type/:entity_id/policy`;
  requestPath = requestPath.replace(':entity_type', encodeURIComponent(entity_type));
  requestPath = requestPath.replace(':entity_id', encodeURIComponent(entity_id));
  const requestOptions = options;
  return client.get<DocumentPolicyResponse>(requestPath, { ...requestOptions });
}
